// extracted by mini-css-extract-plugin
export default {"section":"wristbandStep_section__l1LOE"};